import { Bar, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsBar',
  extends: Bar,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartDataT: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multiChartDataT: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    options: {
      handler: function handler() {
        this.updateBarChart();
      },
      deep: true
    },
    multiChartDataT: {
      handler: function handler() {
        this.updateBarChart();
      },
      deep: true
    },
    chartDataT: {
      handler: function handler() {// this.updateBarChart();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.updateBarChart();
  },
  methods: {
    updateBarChart: function updateBarChart() {
      var mappedChartData = this.mapChartData();
      var chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels || [],
        datasets: mappedChartData.datasets || []
      }, chartOptions);
    },
    mapChartData: function mapChartData() {
      var _this = this;

      var multiChartData = this.multiChartDataT;
      var chartData = this.chartDataT;

      if (multiChartData.individual) {
        return {
          datasets: multiChartData.individual.map(function (dataset, index) {
            var color = multiChartData.common.color ? _this.shadeColor(10 - index * 30, multiChartData.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: dataset.disableHoverColor ? color : undefined,
              backgroundColor: color || 'transparent',
              hoverBackgroundColor: dataset.disableHoverColor ? color : undefined,
              hoverBorderColor: dataset.disableHoverColor ? color : undefined,
              pointRadius: 1,
              borderWidth: 2,
              data: dataset.data
            };
          }),
          labels: multiChartData.common.labels
        };
      } else {
        var color = this.shadeColor(10, chartData.color || '#17bc00');
        return {
          labels: chartData.dataLabels,
          datasets: [{
            label: chartData.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: color || 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            data: chartData.data
          }]
        };
      }
    }
  }
};